<footer>
  <div class="follow" #intro>
    <div class="inner">
      <p [ngClass]="show ? 'show' : ''">Folge uns auch auf anderen Kanälen</p>
      <div class="grid" [ngClass]="show ? 'show' : ''">
        <a href="https://www.instagram.com/dart_rock_cafe" rel="nofollow">
          <picture>
            <source srcset="assets/images/instagram.webp" type="image/webp">
            <img src="assets/images/instagram.png" alt="Dart Rock Cafe Instagram">
          </picture>
        </a>
        <a href="https://www.facebook.com/dartrockcafe" rel="nofollow">
          <picture>
            <source srcset="assets/images/facebook.webp" type="image/webp">
            <img src="assets/images/facebook.png" alt="Dart Rock Cafe Facebook">
          </picture>
        </a>
        <a href="https://www.tiktok.com/@dart.rock.cafe" rel="nofollow">
          <picture>
            <source srcset="assets/images/tiktok.webp" type="image/webp">
            <img src="assets/images/tiktok.png" alt="Dart Rock Cafe TikTok">
          </picture>
        </a>
      </div>
    </div>
  </div>

  <div class="footer" [ngClass]="show ? 'show' : ''">
    <div class="inner">
      <img src="assets/images/DRC-Logo-white.svg" alt="Dart Rock Cafe">
      <div class="address">
        <address>
          Dart Rock Cafe<br>
          Hauptstrasse 46<br>
          34253 Lohfelden<br>
          <a href="tel:+49561123456">0561 123456</a><br>
          <a href="mailto:mail@dart-rock-cafe.de">mail@dart-rock-cafe.de</a>
        </address>
      </div>
      <div class="times">
        <p>Öffnungszeiten</p>
        <div>Mi – Do: 17:00 – 23:00</div>
        <div>Fr: 17:00 – 00:00</div>
        <div>Sa: 17:00 – 01:00</div>
        <div>So – Di: geschlossen</div>
      </div>
      <ul>
        <li>
          <a [routerLink]="['/dart-spielen-kassel']" routerLinkActive="active">Dart spielen in Kassel</a>
        </li>
        <li>
          <a [routerLink]="['/rangliste-2026']" routerLinkActive="active">Steeldart Rangliste</a>
        </li>
        <li>
          <a [routerLink]="['/magazin']" routerLinkActive="active">Dart Magazin</a>
        </li>
        <li>
          <a [routerLink]="['/faq']" routerLinkActive="active">Häufige Fragen</a>
        </li>
        <li>
          <a [routerLink]="['/impressum']" routerLinkActive="active" rel="nofollow">Impressum</a>
        </li>
        <li>
          <a routerLink="/datenschutz" routerLinkActive="active" rel="nofollow">Datenschutz</a>
        </li>
      </ul>
    </div>
  </div>

</footer>
